<div
  class="rounded-lg border bg-card text-card-foreground shadow-xs h-full overflow-hidden flex flex-col"
>
  <!-- <div class="flex flex-col space-y-1.5 p-6"> -->
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <h3 class="text-2xl font-semibold leading-none tracking-tight">
      Administración de Usuarios
    </h3>

    <button type="button" class="primary normal" (click)="openModal()">
      + Nuevo Usuario
    </button>
  </div>

  <div class="grow h-full p-6 pt-0 min-h-0">
    <app-data-table
      [data]="users"
      [columns]="columns"
      [searchable]="true"
      [selectable]="false"
    >
      <ng-template #cellTemplate let-row="row" let-col="col">
        @if (col.key === "user") {
          <div class="flex items-center space-x-3">
            <div
              class="w-10 h-10 bg-secondary rounded-lg flex items-center justify-center shrink-0"
            >
              <ng-icon
                name="lucideUser"
                class="w-5 h-5 text-secondary-foreground"
              ></ng-icon>
            </div>
            <div>
              <p class="text-foreground font-medium text-sm">
                {{ row.username }}
              </p>
              <p class="text-muted-foreground text-xs">
                {{ row.first_name }} {{ row.last_name }}
                {{ row.second_last_name }}
              </p>
            </div>
          </div>
        } @else if (col.key === "actions") {
          <div class="flex items-center justify-center space-x-1">
            <button
              class="ghost sm text-muted-foreground hover:text-foreground"
              type="button"
              (click)="updateUser(row)"
            >
              <ng-icon
                name="lucidePenLine"
                class="w-5 h-5 text-secondary-foreground"
              ></ng-icon>
            </button>

            <button
              class="ghost sm text-destructive"
              type="button"
              (click)="deleteUser(row.id)"
            >
              <ng-icon
                name="lucideTrash2"
                class="w-5 h-5 text-secondary-foreground"
              ></ng-icon>
            </button>
          </div>
        }
      </ng-template>
    </app-data-table>
  </div>
</div>

<app-user-form
  [(showModal)]="showModal"
  [existingUser]="existingUser"
></app-user-form>
